import { FC, useContext, useEffect } from 'react';
import { AppContext } from '../../providers/App/AppContext';
import { withTags } from '@src/utils/tags';

interface ExternalAnalyticsProps {
  gtmContainerId?: string;
}

/**
 * Загружает скрипт GoogleTagManager (GTM) для аналитиков.
 * А с помощью GTM аналитики стартуют google analytics, яндекс метрику и пр.
 * Код window.dataLayer для google analytics, он должен делаться именно так и обязательно
 * до загрузки GTM.
 *
 * Загружается автометов через AppProvider
 */
export const ExternalAnalytics: FC<ExternalAnalyticsProps> = (props) => {
  const { isAuthZone, ngApiClient } = useContext(AppContext);

  useEffect(() => {
    /**
     * Пока нет варианта удобно получать юзера и на авторизованной зоне и на публичной.
     * Просто user из AppContext возвращается ТОЛЬКО в авторизованной зоне, а нам надо получать
     * user в аналитику всегда, когда можем поэтому это сейчас только через ngApiClient
     */
    const user = ngApiClient.getUserInfoFromAccessToken();

    if (user) {
      const isCustomerUser = withTags({ tags: ['customerUser'], user });
      // @ts-ignore
      window.dataLayer = typeof window.dataLayer === 'undefined' ? [] : window.dataLayer;
      // @ts-ignore
      window.dataLayer.push({
        user_id: `${user.id}`,
        is_customer_user: isCustomerUser ? 'true' : 'false',
        is_auth_zone: isAuthZone ? 'true' : 'false',
      });
    }

    if (props.gtmContainerId) {
      // Это код от гугла, подключает Google Tag Manager (GTM)
      // Просто прошел автоформат.
      (function (w, d, s, l, i) {
        // @ts-ignore
        w[l] = w[l] || [];
        // @ts-ignore
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        // @ts-ignore
        j.async = true;
        // @ts-ignore
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        // @ts-ignore
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', props.gtmContainerId);
    }
  }, [isAuthZone, ngApiClient, props.gtmContainerId]);

  return null;
};
